module.exports = __webpack_public_path__ + "assets/img/legion.2f0c4439.svg";